import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CHANNEL_ID_KEY = 'channelId';
const REGISTER_PATH = '/register';

/**
 * 记住入口带来的 channelId，仅在回到报名页时补回 URL。
 */
function ChannelIdPreserver() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const channelId = params.get(CHANNEL_ID_KEY);

    if (channelId) {
      sessionStorage.setItem(CHANNEL_ID_KEY, channelId);
      return;
    }

    if (location.pathname !== REGISTER_PATH) return;

    const stored = sessionStorage.getItem(CHANNEL_ID_KEY);
    if (!stored) return;

    params.set(CHANNEL_ID_KEY, stored);
    const search = params.toString();
    navigate(`${location.pathname}?${search}${location.hash}`, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

export default ChannelIdPreserver;
